// src/utils/highlightMatch.js
import React from "react";

export default function highlightMatch(text = "", query = "") {
  if (!query || !text) return text;
  const regex = new RegExp(`(${query})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, i) =>
    regex.test(part) ? (
      <mark
        key={i}
        style={{
          backgroundColor: "yellow",
          padding: "0 2px",
          borderRadius: "2px",
        }}
      >
        {part}
      </mark>
    ) : (
      part
    )
  );
}
